import { render, staticRenderFns } from "./BodyContent.vue?vue&type=template&id=53629a52&scoped=true&"
import script from "./BodyContent.vue?vue&type=script&lang=js&"
export * from "./BodyContent.vue?vue&type=script&lang=js&"
import style0 from "./BodyContent.vue?vue&type=style&index=0&id=53629a52&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_uesoswnqfrvbmgjykhrr3r374i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53629a52",
  null
  
)

export default component.exports